import React, { useState } from 'react';
import * as Yup from 'yup';
import Input from '../components/common/Input';
import Button from '../components/common/Button';
import { toast } from 'react-toastify';
import { useResetPasswordMutation } from '../redux/apiSlice';
import { Loader2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { resetPasswordSchema } from '../validations/SchemaValidations';

const ResetPassword: React.FC = () => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [resetPassword, { isLoading }] = useResetPasswordMutation();
  const navigate = useNavigate();
  const [formErrors, setFormErrors] = useState<{ [key: string]: string }>({});

  const handleChangeOldPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setOldPassword(e.target.value);
  };

  const handleChangeNewPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewPassword(e.target.value);
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = { oldPassword, newPassword };

    try {
      await resetPasswordSchema.validate(data, { abortEarly: false });
      setFormErrors({});

      await resetPassword(data).unwrap();

      toast.success('Password reset successful!');
      navigate('/courses');
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors: { [key: string]: string } = {};
        error.inner.forEach((err) => {
          if (err.path) {
            errors[err.path] = err.message;
          }
        });
        setFormErrors(errors);
      } else {
        toast.error('Failed to reset password. Please try again.');
      }
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-[85vh]">
      <div className="bg-white p-8 shadow-[0_0_15px_rgba(0,0,0,0.2)] w-[638px] rounded-lg">
        <h1 className="text-[24px] font-bold mb-4">Reset Your Password</h1>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="oldPassword" className="text-xs block font-medium">
              Old Password
            </label>
            <Input
              type="password"
              id="oldPassword"
              name="oldPassword"
              value={oldPassword}
              onChange={handleChangeOldPassword}
              placeholder="Enter your old password"
              disabled={isLoading}
            />
            <p className="text-red-500 text-[13px] h-[4px]">
              {formErrors.oldPassword}
            </p>
          </div>
          <div className="mb-4">
            <label htmlFor="newPassword" className="text-xs block font-medium">
              New Password
            </label>
            <Input
              type="password"
              id="newPassword"
              name="newPassword"
              value={newPassword}
              onChange={handleChangeNewPassword}
              placeholder="Enter your new password"
              disabled={isLoading}
            />
            <p className="text-red-500 text-[13px] h-[4px]">
              {formErrors.newPassword}
            </p>
          </div>
          <div className="flex justify-center">
            <Button
              type="submit"
              className="w-[60%] h-[50px] flex items-center justify-center text-[24px]"
              disabled={isLoading}
            >
              {isLoading ? (
                <Loader2 className="animate-spin h-6 w-6" />
              ) : (
                'Reset Password'
              )}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ResetPassword;
